(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blitz-fine-art-workshop"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('bph-workshop')) {
  customElements.define('bph-workshop', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('click', event => {
        const opener = event.target.closest('[data-dialog-target]');
        if (opener && this.contains(opener)) {
          const dialog = this.querySelector('#' + CSS.escape(opener.dataset.dialogTarget));
          if (dialog && !dialog.open) {
            dialog.returnFocus = opener;
            dialog.showModal();
          }
        }
        const closer = event.target.closest('[data-dialog-close]');
        if (closer) closer.closest('dialog').close();
        if (event.target instanceof HTMLDialogElement) {
          const box = event.target.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
        }
      });
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('close', () => dialog.returnFocus?.focus());
      });
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
